export default __webpack_public_path__ + "static/devops-f62fd4bc5f475a00ce34eb51af0a9cde.png";